/* eslint-disable */
var React = require('react-native');
var {
  NativeModules
} = React;

var NotificationManager = NativeModules.NotificationManager;

//NotificationManager.postNotification("TestEvent")

export default {

  postNotification(event) {
    if (NotificationManager)
    return NotificationManager.postNotification(event)
    else return null
  }
  
  // send a message w/ our notification 
, postNotificationWithString(event, string) {
    if (NotificationManager)
    return NotificationManager.postNotificationWithString(event, string)
    else return null
  }

}
